import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EpdkExpandedStateDirective } from './expanded-state.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [EpdkExpandedStateDirective],
  exports: [EpdkExpandedStateDirective]
})
export class EpdkExpandedStateModule { }